exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right[data-v-f56ca744]{width:18%!important}.mrgtop-2per[data-v-f56ca744]{margin-top:1%}.mrgtop-5px[data-v-f56ca744]{margin-top:4%}.center[data-v-f56ca744]{text-align:center}.heght-1px[data-v-f56ca744]{height:1px}.b-form-input-container[data-v-f56ca744]{margin:4px 0 12px!important}.md-button-color[data-v-f56ca744]{background-color:#607d8d!important}.error[data-v-f56ca744]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f56ca744","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/vehicleQuotation/invoice.vue
// module id = 1846
// module chunks = 0